// extracted by mini-css-extract-plugin
export default {"CompanyPhoto":"Company_CompanyPhoto__GyGfN","CompanyContainer":"Company_CompanyContainer__g+5je"};